import { Classes, InputGroup, Menu, MenuItem } from '@blueprintjs/core';
import { Popover2 } from '@blueprintjs/popover2';
import React, { useRef, useState } from 'react';
import '../../src/suggest/AiosSuggest.scss';
export const DOWN = 'ArrowDown';
export const UP = 'ArrowUp';
export const ENTER = 'Enter';
export const TAB = 'Tab';
export const LEFT = 'ArrowLeft';
export const RIGHT = 'ArrowRight';
export const AiosSuggest = ({ suggestions, placeholder, value, onChange, className, disabled = false, }) => {
    const [items, setItems] = useState(suggestions);
    const [inputValue, setInputValue] = useState(value ? value : '');
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [customValue, setCustomValue] = useState(false);
    const [leaveFocus, setLeaveFocus] = useState(true);
    const input = useRef(null);
    const onLeaveFocus = () => {
        setLeaveFocus(true);
    };
    const onFocus = () => {
        setLeaveFocus(false);
        setPopoverOpen(true);
    };
    const onTypedInput = (input) => {
        onChange(input);
        setPopoverOpen(true);
        setInputValue(input);
        setItems(filterItems(input));
        setSelectedIndex(0);
    };
    const filterItems = (input) => {
        const items = suggestions.filter((s) => s.toLowerCase().indexOf(input.toLowerCase()) !== -1);
        if (items.length > 0) {
            setCustomValue(false);
            return items;
        }
        setCustomValue(true);
        setPopoverOpen(false);
        return [];
    };
    const chooseSuggestion = (selection) => {
        setInputValue(selection);
        if (selection !== value) {
            onChange(selection);
        }
        setPopoverOpen(false);
    };
    const incrementSelectedIndex = () => {
        const incrementedIndex = selectedIndex + 1;
        if (incrementedIndex >= items.length) {
            setSelectedIndex(0);
        }
        else {
            setSelectedIndex(incrementedIndex);
        }
    };
    const decrementSelectedIndex = () => {
        const decrementedIndex = selectedIndex - 1;
        if (decrementedIndex < 0) {
            setSelectedIndex(items.length - 1);
        }
        else {
            setSelectedIndex(decrementedIndex);
        }
    };
    const getInputValue = () => {
        return input.current?.value || '';
    };
    const handleKeyboardNavigation = (eventKey, event) => {
        switch (eventKey) {
            case DOWN:
                event.stopPropagation();
                setPopoverOpen(true);
                incrementSelectedIndex();
                break;
            case UP:
                event.stopPropagation();
                setPopoverOpen(true);
                decrementSelectedIndex();
                break;
            case ENTER:
                event.stopPropagation();
                const enteredValue = customValue ? getInputValue() : items[selectedIndex];
                chooseSuggestion(enteredValue);
                break;
            case TAB:
                if (popoverOpen) {
                    event.preventDefault();
                }
                onChange(inputValue);
                setPopoverOpen(false);
                break;
            case LEFT:
            case RIGHT:
                if (popoverOpen) {
                    event.preventDefault();
                }
                setPopoverOpen(false);
        }
    };
    const onInteraction = (nextOpenState) => {
        requestAnimationFrame(() => {
            if (input != null && input.current !== document.activeElement) {
                // the input is no longer focused so we can close the popover
                const inputValue = getInputValue();
                if (inputValue !== value) {
                    onChange(inputValue);
                }
                setPopoverOpen(nextOpenState);
            }
        });
    };
    const defaultStyle = {
        borderRadius: '3px',
        outline: 'none',
        height: '28px',
        margin: '0',
        width: '100%',
    };
    const operationStyle = {
        focus: {
            ...defaultStyle,
            border: 'solid 1px var(--main-green-1)',
            color: 'var(--main-green-1)',
            boxShadow: 'none',
            width: '100%',
        },
        none: { ...defaultStyle },
    };
    return (React.createElement("div", { className: className },
        React.createElement(Popover2, { minimal: true, position: 'bottom-left', isOpen: popoverOpen, onInteraction: onInteraction, enforceFocus: false, disabled: disabled, content: React.createElement(Menu, { className: 'AiosSuggestMenu', "data-testid": 'menuId' }, items.map((suggestion, i) => (React.createElement(MenuItem, { role: 'menuItem', "data-testid": `menuItem-${i}`, shouldDismissPopover: true, key: i, text: suggestion, onClick: () => chooseSuggestion(suggestion), active: i === selectedIndex && !customValue, className: Classes.POPOVER_DISMISS_OVERRIDE })))) },
            React.createElement(InputGroup, { className: `${className}-input`, role: 'inputAiosSuggest', placeholder: placeholder, onChange: (e) => onTypedInput(e.target.value), value: inputValue, inputRef: input, onKeyDown: (event) => handleKeyboardNavigation(event.key, event), onFocus: onFocus, onBlur: onLeaveFocus, onClick: () => {
                    setPopoverOpen(true);
                    input.current?.focus();
                }, style: !leaveFocus ? operationStyle.focus : operationStyle.none, disabled: disabled }))));
};
//# sourceMappingURL=AiosSuggest.js.map